module.exports = __webpack_public_path__ + "img/calendar.45fc2c60.svg";